import {
    getList
} from '@/api/card';
import store from '@/store'



const state = {
    goodsGroupId: 0,
    orderCards: []
}
const mutations = {
    ADD_CARD: (state, card) => {
        for (let ckey in state.orderCards) {
            if (state.orderCards[ckey].iccid == card.iccid) {
                return
            }
        }
        state.orderCards.push(card)
    },
    DEL_CARD: (state, card) => {
        state.orderCards.splice(state.orderCards.indexOf(card), 1)
        if (state.orderCards.length == 0) {
            state.goodsGroupId = 0
        }
    },
    CLEAR: (state) => {
        state.goodsGroupId = 0
        state.orderCards = []
    },
}


const actions = {
    add({ commit, state }, iccidRange) {
        return new Promise((resolve, reject) => {
            getList({
                start_card_no: iccidRange.start_card_no,
                end_card_no: iccidRange.end_card_no,
                page_size: 15000
            }).then(res => {
                for (let key in res.data.list) {
                    if (!res.data.list[key].goods_group) {
                        reject("卡未设置套餐组")
                        return
                    } else if (state.goodsGroupId == 0) {
                        state.goodsGroupId = res.data.list[key].goods_group.id
                    } else if (state.goodsGroupId != res.data.list[key].goods_group.id) {
                        reject("卡不属于同一套餐组")
                        return
                    }
                    if (store.getters.agentId != res.data.list[key].agent.id) {
                        reject("卡不属于当前代理商")
                        return
                    }
                }
                let cards = res.data.list.map(item => {
                    return { iccid: item.iccid }
                })
                for (let key in cards) {
                    commit('ADD_CARD', cards[key])
                }
                resolve(cards)
            })
        })
    }
}



export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/batchbuy.js